import { render, staticRenderFns } from "./AlbumComponent.vue?vue&type=template&id=23e5fc83&scoped=true"
import script from "./AlbumComponent.vue?vue&type=script&lang=js"
export * from "./AlbumComponent.vue?vue&type=script&lang=js"
import style0 from "./AlbumComponent.vue?vue&type=style&index=0&id=23e5fc83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e5fc83",
  null
  
)

export default component.exports